"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.edit.title': 'Editar Prueba de Bot',
};
